import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { ApiService } from '@core/services/api.service';
import { environment } from '@env/environment';
import { GatilhoAlertas, LocalExibicaoAlertas, ModoExibicaoAlertas, StatusAlertas, TipoAlertas } from '@modules/gestao-alertas/models/alerta';
import { of } from 'rxjs';


const routes = {
  listarAlertas: `alert-manager/alerts/search`,
  getAlerta: (id: number) => `alert-manager/alerts/${id}`,
  getAlertasAtivos: `alert-manager/alerts/page`,
  criarAlerta: `alert-manager/alerts`,
  editarAlerta: (id: number) => `alert-manager/alerts/${id}`,
  ativarInativarAlerta: (id: number) => `alert-manager/alerts/${id}/status`,
  excluirAlerta: (id: number) => `alert-manager/alerts/${id}`,
  ativarInativarAlertasMultiplos: `alert-manager/alerts/status`,
}

@Injectable({
  providedIn: 'root'
})
export class GestaoAlertasService {

  constructor(private apiService: ApiService, private router: Router) { }

  modosExibicaoAlertas: ModoExibicaoAlertas[] = [
    { id: 1, type: "Modal" },
    { id: 2, type: "Alerta" },
    // { id: 3, type: "Toast" },
    // { id: 4, type: "Popover" }
  ]

  tiposAlertas: TipoAlertas[] = [
    { id: 1, type: 'Alerta' },
    { id: 2, type: 'Informação' },
    { id: 3, type: 'Sucesso' },
    { id: 4, type: 'Erro' }
  ];

  gatilhosAlertas: GatilhoAlertas[] = [
    { id: 1, type: 'Carregamento de página', value: null },
    { id: 3, type: 'Scroll de página', value: null },
    { id: 4, type: 'Tempo de página', value: null }
  ]

  statusAlertas: StatusAlertas[] = [
    { id: 1, type: 'Ativo', value: true },
    { id: 2, type: 'Inativo', value: false }
  ]

  listarAlertas(filtro) {
    return this.apiService.postCustomApi<any>(`${environment.lote}/${routes.listarAlertas}`, filtro);
  }

  getAlerta(id: number) {
    return this.apiService.getCustomApi<any>(`${environment.lote}/${routes.getAlerta(id)}`)
  }

  getAlertaAtivo(parametros: any) {
    let params = new HttpParams();
    if (parametros.startsWith('/consulta')) {
      const match = parametros.match(/^\/consulta\/(\d+)\/(\d+)\/(\d+)\//);
      if (match) {
        const parametrosTratados = {
          ramo: match[1],
          produto: match[2],
          consulta: match[3],
        };
        if (parametrosTratados?.produto) {
          params = params.append('productId', parametrosTratados.produto);

          return this.apiService.getCustomApi<any>(
            `${environment.lote}/${routes.getAlertasAtivos}`,
            params
          );
        }
      }
    } else if (parametros) {
      // Early return para rotas públicas
      if (parametros.startsWith('/publico')) return

      params = params.append('path', parametros);
      return this.apiService.getCustomApi<any>(
        `${environment.lote}/${routes.getAlertasAtivos}`,
        params)
    }
  }

  criarAlerta(data) {
    return this.apiService.postCustomApi<any>(`${environment.lote}/${routes.criarAlerta}`, data)
  }

  editarAlerta(data, id) {
    return this.apiService.putCustomApi<any>(`${environment.lote}/${routes.editarAlerta(id)}`, data)
  }

  excluirAlerta(id: number) {
    return this.apiService.deleteCustomApi<any>(`${environment.lote}/${routes.excluirAlerta(id)}`)
  }

  ativarInativarAlerta(id: number, param: boolean) {
    let params = new HttpParams();
    params = params.append('active', param);

    return this.apiService.putCustomApi<any>(`${environment.lote}/${routes.ativarInativarAlerta(id)}`, params)
  }

  ativarInativarAlertasMultiplos(data) {
    return this.apiService.putCustomApi<any>(`${environment.lote}/${routes.ativarInativarAlertasMultiplos}`, data)
  }

  public getModosExibicao() {
    return of(this.modosExibicaoAlertas);
  }

  public getTiposAlertas() {
    return of(this.tiposAlertas);
  }

  public getGatilhosAlertas() {
    return of(this.gatilhosAlertas);
  }

  public getStatusAlertas() {
    return of(this.statusAlertas);
  }
}
